module.exports = __webpack_public_path__ + "static/media/didi_playing_baja_head.31fb4036.png";